module.exports = __webpack_public_path__ + "media/images/Instagram-309a671a5f8f4b04866a2c6d48503ff7.jpg";